import { ThemeContext } from "@emotion/react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../components/Loading/useLoading";
import { Button, Paper } from "@mui/material";
import { GroupingTable } from "../../../components/Table/grouping_table";
import moment from "moment";
import { CopiarReporte, GetReportesList } from "../../../hooks/reporteQuery";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";


export const TablaQuerys = () => {

  const username = useSelector((state) => state.auth.user.username);
  const navigate = useNavigate();
  const {setAppLoading} = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { getReportesListMutation } = GetReportesList();
  const { copiarReporteMutation } = CopiarReporte();
  const [rows, setRows] = useState([]);
  const sort = {}

  const columns = [
    {
      accessorKey: 'repo_nombre',
      header: 'Nombre',
    }, 
    {
      accessorKey: 'repo_desc',
      header: 'Descripción',
    }, 
    {
      accessorFn: (row) => moment(row?.repo_fecha, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY") || '',
      id: 'fecha',
      header: 'Fecha',
      sortingFn: 'text',
      filterFn: 'includesString',
    },
    {
      accessorFn: (row) => username === row?.usu_id ? <Button variant="contained" className="btn_system" sx={{width: '120px'}} onClick={() => copy_reporte(row)}>Copiar</Button> : '',
      id: 'copiar',
      header: '',
    },
    {
      accessorFn: (row) => username === row?.usu_id ? <Button variant="contained" className="btn_system" sx={{width: '120px'}} onClick={() => redirect_edit(row)}>Editar</Button> : '',
      id: 'editar',
      header: '',
    },
    {
      accessorFn: (row) => <Button variant="contained" className="btn_system" sx={{width: '120px'}} onClick={() => redirect(row)}>Ver</Button> || '',
      id: 'ver',
      header: '',
    }
  ];

  const redirect = (row) => {
    if(row){
      navigate(`/reportes/personalizado/visual/${row?.repo_id}`);
    }
  }
  const redirect_edit = (row) => {
    if(row){
      navigate(`/reportes/personalizado/editar/${row?.repo_id}`);
    }
  }

  const get_reportes_enviados = () => {
    setAppLoading(true)
    getReportesListMutation({},{
      onSuccess: (data) => {
        setRows(data.data);
        setAppLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setAppLoading(false);
      }
    })
  };

  useEffect(() => {
    get_reportes_enviados();
  }, []);

  const copy_reporte = (row) => {
    setAppLoading(true)
    copiarReporteMutation(row?.repo_id,{
      onSuccess: (data) => {
        setAppLoading(false);
        enqueueSnackbar(data?.mensaje, { 
          variant: data?.success ? 'success' : 'error',
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          }, 
        });
        get_reportes_enviados();
      },
      onError: (error) => {
        console.log(error);
        enqueueSnackbar('Hubo un error al copiar el reporte', { 
          variant: 'error',
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          }, 
        });
        setAppLoading(false);
      }
    })
  }

  return(
    <Paper style={{ height: '100%', width: '100%' }} sx={{boxShadow:'none'}}>
      <GroupingTable  
      key='tabla_reportes_querys' 
      columnas={columns} 
      data={rows} 
      redirect={()=>console.log('row')}
      sort={sort}
      />
    </Paper>
  )
}